// extracted by mini-css-extract-plugin
export var columnItem = "_ff-3";
export var columnItemDraggable = "_ff-5";
export var dragHandle = "_ff-0";
export var dragHandleHovered = "_ff-1";
export var dropdown = "_ff-6";
export var dropdownContent = "_ff-8";
export var dropdownInner = "_ff-7";
export var filterDropdownHeader = "_ff-9";
export var icon = "_ff-2";
export var moveToTopButton = "_ff-4";
export var sectionDivider = "_ff-a";